export type Role = 'user' | 'assistant' | 'system';

export interface Conversation {
  id: string;
  title: string;
  createdAt: number;
  updatedAt: number;
}

export interface Message {
  id: string;
  conversationId: string;
  role: Role;
  content: string;
  createdAt: number;
  metadata?: Record<string, unknown>;
}

export interface Memory {
  id: string;
  conversationId: string | null;
  situation: string;
  decision: string;
  action: string;
  learning: string;
  tags: string[];
  createdAt: number;
  updatedAt: number;
}

export interface FollowUp {
  result?: string | null;
  learning?: string | null;
  id: string;
  memoryId: string | null;
  conversationId: string | null;
  title: string;
  description: string | null;
  dueDate: number | null;
  recurrence: 'daily' | 'weekly' | 'monthly' | null;
  status: 'pending' | 'done' | 'cancelled';
  completedAt: number | null;
  createdAt: number;
  updatedAt: number;
}

export interface Reminder {
  monthlyDay?: number | null;
  timeZone?: string;
  conversationId?: string | null;
  occurrenceId?: string | null;
  firedAt?: number | null;
  id: string;
  title: string;
  body: string | null;
  triggerAt: number;
  recurrence: 'daily' | 'weekly' | 'monthly' | null;
  status: 'active' | 'triggered' | 'dismissed';
  createdAt: number;
}

export interface SearchResult {
  title: string;
  url: string;
  snippet: string;
}

export type Tag = 'pessoas' | 'manutencao' | 'compras' | 'financeiro' | 'administrativo' | string;

export const DEFAULT_TAGS: Tag[] = ['pessoas', 'manutencao', 'compras', 'financeiro', 'administrativo'];

export function formatDate(ts: number): string {
  const d = new Date(ts);
  return d.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' });
}

export function formatTime(ts: number): string {
  const d = new Date(ts);
  return d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
}

export function formatDateTime(ts: number): string {
  return `${formatDate(ts)} ${formatTime(ts)}`;
}

export function isOverdue(ts: number | null): boolean {
  if (!ts) return false;
  return ts < Date.now();
}

export function generateId(): string {
  return `${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
}